import { ICopyable } from '../core/copyable.interface';

export class Box implements ICopyable<Box> {
    id: string = null;
    name: string = null;
    order: number = null;
    groupId: string = null;
    defaultBox: boolean = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): Box {
        const instance = new Box();
        instance.id = this.id;
        instance.name = this.name;
        instance.order = this.order;
        instance.groupId = this.groupId;
        instance.defaultBox = this.defaultBox;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.order = other.order;
        this.groupId = other.groupId;
        this.defaultBox = other.defaultBox;
    }

    /**
     * Retourne une instance de Box à partir d'une instance de Box.
     * @param other : Instance de Box.
     * @returns : Instance de Box.
     */
    public static from(other: Box) {
        if (!!other) {
            const instance = new Box();

            instance.id = other.id;
            instance.name = other.name;
            instance.order = other.order;
            instance.groupId = other.groupId;
            instance.defaultBox = other.defaultBox;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de Box à partir d'un tableau d'instances de Box.
     * @param other : Tableau d'instances de Box.
     * @returns : Tableau d'instances de Box.
     */
    public static fromArray(others: Box[]) {
        if (!!others) {
            let boxes: Box[] = [];

            others.forEach((x) => {
                const box = Box.from(x);
                boxes.push(box);
            });

            return boxes;
        } else {
            return null;
        }
    }
}
